import {Component} from '@angular/core';

@Component({
  selector: 'app-offline-dialog',
  templateUrl: './offline-dialog.component.html',
})
export class OfflineDialogComponent {

  onSubmit() {
    window.location.reload();
  }

}
